var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h2',[_vm._v(_vm._s(_vm.title || 'secret'))]),_c('v-md-editor',{attrs:{"height":"600px"},on:{"save":_vm.updateSecret},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }